module.exports = __webpack_public_path__ + "officialStatic/img/detail-eight-bg.c6d85c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-eight-bg.png
// module id = DRhD
// module chunks = 0